<form
  [formGroup]="form"
  class="form-container"
>
  <eps-label-body
    label="ORDERS.DELIVERY.LABELS.RECURRENCE"
    [readonly]="!isEdit"
    [labelWidth]="labelWidth"
  >
    <div
      class="col-12 col-md-10"
      *ngIf="isEdit"
    >
      <div class="row">
        <div class="col-12 recurrence-checkbox-div">
          <eps-checkbox
            labelPosition="none"
            formControlName="active"
          ></eps-checkbox>
        </div>
      </div>
      <div
        class="row"
        *ngIf="isEdit"
      >
        <div class="col-12">
          <div
            [hidden]="!form.value.active"
            [ngClass]="{ 'transition-show': form.value.active }"
            class="recurrence-container col-12"
          >
            <eps-radio-group
              label="ORDERS.DELIVERY.LABELS.RECURRENCY_PATTERN"
              labelPosition="top"
              formControlName="pattern"
              [showErrors]="false"
              [options]="recurrencyPatternOptions"
              [radioButtonsDirection]="(isExtraSmall$ | async) ? 'column' : 'row'"
              autoSelect
            ></eps-radio-group>

            <div formGroupName="weekly">
              <div
                class="row"
                *ngIf="form.value.pattern === RECURRENCE_PATTERN_WEEKLY"
              >
                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.MONDAY"
                    formControlName="monday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="mondayRecurrence"
                    [min]="1"
                    [max]="10"
                    [clearable]="false"
                    *ngIf="form.value.weekly.monday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.TUESDAY"
                    formControlName="tuesday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="tuesdayRecurrence"
                    [clearable]="false"
                    [min]="1"
                    [max]="10"
                    *ngIf="form.value.weekly.tuesday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.WEDNESDAY"
                    formControlName="wednesday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="wednesdayRecurrence"
                    [clearable]="false"
                    [min]="1"
                    [max]="10"
                    *ngIf="form.value.weekly.wednesday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.THURSDAY"
                    formControlName="thursday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="thursdayRecurrence"
                    [clearable]="false"
                    [min]="1"
                    [max]="10"
                    *ngIf="form.value.weekly.thursday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.FRIDAY"
                    formControlName="friday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="fridayRecurrence"
                    [clearable]="false"
                    [min]="1"
                    [max]="10"
                    *ngIf="form.value.weekly.friday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.SATURDAY"
                    formControlName="saturday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="saturdayRecurrence"
                    [clearable]="false"
                    [min]="1"
                    [max]="10"
                    *ngIf="form.value.weekly.saturday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="weekly-row">
                  <eps-checkbox
                    labelPosition="none"
                    checkboxLabel="SHARED.DAYS.SUNDAY"
                    formControlName="sunday"
                  ></eps-checkbox>
                  <eps-number-input
                    labelPosition="none"
                    formControlName="sundayRecurrence"
                    [clearable]="false"
                    [min]="1"
                    [max]="10"
                    *ngIf="form.value.weekly.sunday && !isRelocation"
                  ></eps-number-input>
                </div>

                <div class="col-md-12">
                  <app-error
                    translationCode="validation-error.custom.recurrence.atLeastOneDay"
                    [showError]="this.form.controls.weekly.invalid"
                  ></app-error>
                </div>
              </div>
            </div>

            <div
              class="row monthly"
              formGroupName="monthly"
            >
              <div
                class="col-12"
                *ngIf="form.value.pattern === RECURRENCE_PATTERN_NR_OF_DAY"
              >
                <div class="container monthly_sub">
                  <div class="vert_center">
                    <span class="text">{{ 'ORDERS.DELIVERY.LABELS.MONTHLY.DAY' | translate }}&nbsp;</span>
                    <eps-number-input
                      labelPosition="none"
                      [min]="1"
                      [max]="31"
                      formControlName="day"
                      class="day"
                      [clearable]="false"
                      [showErrors]="false"
                    ></eps-number-input>
                    <span class="text">&nbsp;{{ 'ORDERS.DELIVERY.LABELS.MONTHLY.OF_EVERY' | translate }}&nbsp;</span>
                    <eps-number-input
                      labelPosition="none"
                      [min]="1"
                      [max]="12"
                      formControlName="monthPeriodicy1"
                      class="monthPeriodicy1"
                      [clearable]="false"
                      [showErrors]="false"
                    ></eps-number-input>
                    <span class="text">&nbsp;{{ 'ORDERS.DELIVERY.LABELS.MONTHLY.MONTHS' | translate }}</span>
                  </div>
                </div>
              </div>
              <div
                class="col-12"
                *ngIf="form.value.pattern === RECURRENCE_PATTERN_WHICH_DAY"
              >
                <div class="container monthly_sub">
                  <div class="vert_center">
                    <span class="text">{{ 'ORDERS.DELIVERY.LABELS.MONTHLY.THE' | translate }}&nbsp;</span>
                    <eps-select
                      class="which"
                      [options]="ordinalEnum"
                      formControlName="which"
                      labelPosition="none"
                      [clearable]="false"
                      [showErrors]="false"
                    ></eps-select>
                    <eps-select
                      class="weekday"
                      [options]="weekdayEnum"
                      formControlName="weekday"
                      labelPosition="none"
                      [clearable]="false"
                      [showErrors]="false"
                    ></eps-select>
                    <span class="text">&nbsp;{{ 'ORDERS.DELIVERY.LABELS.MONTHLY.OF_EVERY' | translate }}&nbsp;</span>
                    <eps-number-input
                      labelPosition="none"
                      formControlName="monthPeriodicy2"
                      class="monthPeriodicy2"
                      [clearable]="false"
                      [min]="1"
                      [max]="12"
                      [showErrors]="false"
                    ></eps-number-input>
                    <span class="text">&nbsp;{{ 'ORDERS.DELIVERY.LABELS.MONTHLY.MONTHS' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            [hidden]="!form.value.active"
          >
            <eps-date-input
              formControlName="endDate"
              [validRanges]="[endDateValidRange]"
              label="ORDERS.DELIVERY.LABELS.END_DATE_RECURRENCE"
              labelPosition="top"
            ></eps-date-input>
          </div>
        </div>
      </div>
    </div>
    <div
      class="recurrence-readonly"
      *ngIf="!isEdit"
    >
      <eps-checkbox
        formControlName="active"
        readonly
        *ngIf="!form.value.active"
        [useIconsInReadonly]="true"
        labelPosition="none"
      ></eps-checkbox>
      <span *ngIf="form.value.active">{{ recurrencyPattern }} {{ endPattern }}</span>
    </div>
  </eps-label-body>
</form>
